export enum NotificationStatus {
  PENDING = 'pending',
  SENDING = 'sending',
  SENT = 'sent',
  FAILED = 'failed',
}

export enum NotificationRecipientType {
  ALL_MANAGERS = 'all_managers',
  WIP_ONLY = 'wip_only',
}

export type NotificationEntity = {
  id: number;
  form_id: number;
  recipient_type: NotificationRecipientType;
  subject: string;
  message: string;
  status: NotificationStatus;
  recipients_count: number;
  sent_count: number;
  author_id: number;
  author_email: string;
  author_name: string;
  created_at: string;
  updated_at: string;
};

export type GetNotificationsRequest = {
  id: number;
};

export type GetNotificationsResponse = {
  notifications: NotificationEntity[];
  total: number;
};
